import React, { useState } from "react";
/** Components Import */
import { Tab, Nav } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
/** Styles Import */
import "./Style.css";

const BottomTabs = ({
  containerClassName = "",
  navClassName = "",
  navItemClassName = "",
  navLinkClassName = "",
  fontClassName = "",
  nameClassName = "",
  items = [],
  value,
  onSelect = (e) => {},
}) => {
  const SelectTab = (e) => {
    onSelect(e);
  };

  return (
    <div className={`${containerClassName} bottom-tab-container`}>
      <Tab.Container activeKey={value} onSelect={SelectTab}>
        <Nav className={`${navClassName} bottom-tabs`}>
          {items.map((item, index) => {
            return item.value == "Setting" ? null : (
              <Nav.Item className={navItemClassName} key={index}>
                <Nav.Link
                  className={navLinkClassName}
                  onClick={() => item.onClick()}
                  eventKey={item.value}
                >
                  <FontAwesomeIcon className={fontClassName} icon={item.icon} />
                  <span className={nameClassName}>{item.text}</span>
                </Nav.Link>
              </Nav.Item>
            );
          })}
        </Nav>
      </Tab.Container>
    </div>
  );
};

export default BottomTabs;
